/**
 * Resolve a URL suitable for <img src> — converts HEIC/HEIF to JPEG in the browser when needed.
 */
import { heicTo } from 'heic-to';

export function isHeicMime(mime?: string): boolean {
  const m = (mime || '').toLowerCase();
  return m === 'image/heic' || m === 'image/heif';
}

export type DisplayableImageResult = {
  url: string;
  /** Revoke object URL when the preview is closed (HEIC conversion only). */
  revoke: () => void;
};

/**
 * For normal images returns the original URL with a no-op revoke.
 * For HEIC/HEIF fetches, converts to JPEG, and returns an object URL — caller must call revoke() on unmount.
 */
export async function getDisplayableImageUrl(sourceUrl: string, mimeType?: string): Promise<DisplayableImageResult> {
  const noop = () => {};
  if (!isHeicMime(mimeType)) {
    return { url: sourceUrl, revoke: noop };
  }
  try {
    const res = await fetch(sourceUrl);
    const blob = await res.blob();
    const jpegBlob = await heicTo({ blob, type: 'image/jpeg', quality: 0.9 });
    const objectUrl = URL.createObjectURL(jpegBlob);
    return {
      url: objectUrl,
      revoke: () => URL.revokeObjectURL(objectUrl),
    };
  } catch (err) {
    console.error('HEIC preview failed:', err);
    throw err;
  }
}
